import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button"];

  connect() {
    this.deferredPrompt = null;
    this.onBeforeInstallPrompt = this.onBeforeInstallPrompt.bind(this);
    this.onAppInstalled = this.onAppInstalled.bind(this);

    window.addEventListener("beforeinstallprompt", this.onBeforeInstallPrompt);
    window.addEventListener("appinstalled", this.onAppInstalled);

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/service-worker.js").catch(() => {});
    }

    if (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone
    ) {
      this.hideButton();
    }
  }

  disconnect() {
    window.removeEventListener(
      "beforeinstallprompt",
      this.onBeforeInstallPrompt,
    );
    window.removeEventListener("appinstalled", this.onAppInstalled);
  }

  onBeforeInstallPrompt(event) {
    event.preventDefault();
    this.deferredPrompt = event;
    this.showButton();
  }

  async prompt() {
    if (!this.deferredPrompt) {
      return;
    }

    this.deferredPrompt.prompt();
    await this.deferredPrompt.userChoice;
    this.deferredPrompt = null;
    this.hideButton();
  }

  onAppInstalled() {
    this.deferredPrompt = null;
    this.hideButton();
  }

  showButton() {
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.remove("hidden");
    }
  }

  hideButton() {
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.add("hidden");
    }
  }
}
